import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Center, Button, Title, Space, Group, Stack, Image } from '@mantine/core';
import backButton from '../../image/back-button.svg';
import home from '../../image/home.svg';

const Home = () => {
  const navigate = useNavigate();

  const ticket = () => {
    navigate('/findmycarstation/ticketnumber');
  };
  const qrScaner = () => {
    navigate('/findmycarstation/findmycar');
  };
  const vehicle = () => {
    navigate('/findmycarstation/numberplate');
  };

  const [serviceData, setServiceData] = useState([]);

  const queryParam = `?long=77.669907&lat=12.900836`;
  const token =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwNSIsIm1vYmlsZSI6Ijk3OTE0MjY2ODEiLCJpc0FjdGl2ZSI6dHJ1ZSwiaWF0IjoxNjYwMTM2MDgxLCJleHAiOjE2NjA3NDA4ODF9.Bh_KrcRhb5Ku9RSvJ9nCo6zCLTAX5ibxO-a59hNDL0g';
  useEffect(() => {
    fetch(`https://sp.api.v2.hyperthings.in/api/v1/sites/${685}/${queryParam}`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((json) => setServiceData(json));
  }, [queryParam, serviceData]);

  return (
    <Box>
      <Center p="xl">
        <Stack>
          <Title style={{ color: 'yellow' }} order={1}>
            Welcome to the ABC parking!!
          </Title>
          <Center>
            <Title style={{ color: 'yellow' }} order={2}>
              Find My Car
            </Title>
          </Center>
        </Stack>
      </Center>

      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Center>
        <Group spacing="xl">
          <Button color="blue" size="xl" onClick={vehicle}>
            Enter Number Plate
          </Button>
          <Button color="blue" size="xl" onClick={ticket}>
            Enter Ticket Number
          </Button>
          <Button color="blue" size="xl" onClick={qrScaner}>
            Ticket Scanner
          </Button>
        </Group>
      </Center>
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }} p="lg">
        <Button
          onClick={() => navigate(-1)}
          color="blue"
          size="xl"
          leftIcon={<Image src={backButton} width={30} height={30} />}
        >
          Go Back
        </Button>
        <Button
          onClick={() => navigate('/')}
          color="blue"
          size="xl"
          leftIcon={<Image src={home} width={30} height={30} />}
        >
          Home
        </Button>
      </Group>
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
    </Box>
  );
};

export default Home;
